/**
 * BudgetState — the user-chosen ride budget in minutes (0 = unlimited).
 * startTime anchors the countdown. BudgetTimer emits budget:tick
 * events that this model reacts to, recomputing remainingMin.
 *
 * Emits `budget:changed` when the user adjusts the budget or a tick
 * changes the remaining time.
 */
export class BudgetState {
    constructor(_bus) {
        this._bus = _bus;
        this._budgetMin = 60;
        this._startTime = Date.now();
    }
    setBudgetMin(min) {
        this._budgetMin = Math.max(0, Math.round(min));
        this._bus.emit('budget:changed', this.snapshot());
    }
    resetStart() {
        this._startTime = Date.now();
        this._bus.emit('budget:changed', this.snapshot());
    }
    get budgetMin() {
        return this._budgetMin;
    }
    get startTime() {
        return this._startTime;
    }
    get isUnlimited() {
        return this._budgetMin === 0;
    }
    /** Minutes remaining. -1 = unlimited (sentinel used in IACP messages) */
    getRemainingMin() {
        if (this._budgetMin === 0)
            return -1;
        const elapsedMs = Date.now() - this._startTime;
        const elapsedMin = elapsedMs / 60000;
        return Math.max(0, Math.round(this._budgetMin - elapsedMin));
    }
    snapshot() {
        return {
            budgetMin: this._budgetMin,
            startTime: this._startTime,
            remainingMin: this.getRemainingMin(),
            isUnlimited: this.isUnlimited,
        };
    }
}
//# sourceMappingURL=BudgetState.js.map